const headerPaddingForPage = () => {
    const page = document.querySelector('.Page');
    const header = document.querySelector('.Header');

    if (page && header) {
        const headerHeight = header.offsetHeight;
        const windowWidth = page.offsetWidth;
        let margin = 32;
        if (windowWidth > 743) {
            margin = 48;
        }
        page.style.paddingTop = `${margin + headerHeight}px`;
    }
};

export default headerPaddingForPage;
